import {
  AntDesignOutlined,
  AppstoreOutlined,
  ContainerOutlined,
  DashboardOutlined,
  FileTextOutlined,
  LinkOutlined,
  SearchOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { AutoComplete, Input } from 'antd';
import IntlMessage from 'components/util-components/IntlMessage';
import navigationConfig from 'configs/NavigationConfig';
import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';

function getOptionList(navigationTree, optionTree) {
  optionTree = optionTree ? optionTree : [];
  for (const navItem of navigationTree) {
    if (navItem.submenu.length === 0) {
      optionTree.push(navItem);
    }
    if (navItem.submenu.length > 0) {
      getOptionList(navItem.submenu, optionTree);
    }
  }
  return optionTree;
}

const optionList = getOptionList(navigationConfig);

const getCategoryIcon = (category) => {
  switch (category) {
    case 'dashboards':
      return <DashboardOutlined style={{ color: '#703be7' }} />;
    case 'propostas':
      return <ContainerOutlined style={{ color: '#703be7' }} />;
    case 'crefaz':
      return <ContainerOutlined style={{ color: '#703be7' }} />;
    case 'icred':
      return <ContainerOutlined style={{ color: '#703be7' }} />;
    case 'clientes':
      return <UserOutlined style={{ color: '#703be7' }} />;
    case 'benefits':
      return <SettingOutlined style={{ color: '#703be7' }} />;
    case 'operations':
      return <SettingOutlined style={{ color: '#703be7' }} />;
    case 'agreements':
      return <SettingOutlined style={{ color: '#703be7' }} />;
    case 'bank':
      return <SettingOutlined style={{ color: '#703be7' }} />;
    case 'liberationFont':
      return <SettingOutlined style={{ color: '#703be7' }} />;
    case 'usuarios':
      return <UserOutlined style={{ color: '#703be7' }} />;
    case 'useful':
      return <LinkOutlined style={{ color: '#703be7' }} />;
    case '':
      return <SettingOutlined style={{ color: '#703be7' }} />;
    default:
      return <LinkOutlined style={{ color: '#703be7' }} />;
  }
};

const searchResult = () =>
  optionList.map((item) => {
    const category = item.key.split('-')[0];
    return {
      value: item.path,
      label: (
        <Link to={item.path}>
          <div className='search-list-item'>
            <div className='icon'>{getCategoryIcon(category)}</div>
            <div>
              <div className='font-weight-semibold'>
                <IntlMessage id={item.title} />
              </div>
              <div className='font-size-sm text-muted'>{category} </div>
            </div>
          </div>
        </Link>
      ),
    };
  });

const SearchInput = (props) => {
  const { active, close, isMobile, mode } = props;
  const [value, setValue] = useState('');
  const [options, setOptions] = useState([]);
  const inputRef = useRef(null);

  const onSelect = () => {
    setValue('');
    setOptions([]);
    if (close) {
      close();
    }
  };

  const onSearch = (searchText) => {
    setValue(searchText);
    setOptions(!searchText ? [] : searchResult(searchText));
  };

  const autofocus = () => {
    inputRef.current.focus();
  };

  if (active) {
    autofocus();
  }

  return (
    <AutoComplete
      ref={inputRef}
      className={`nav-search-input ${isMobile ? 'is-mobile' : ''} ${
        mode === 'light' ? 'light' : ''
      }`}
      dropdownClassName='nav-search-dropdown'
      options={options}
      onSelect={onSelect}
      onSearch={onSearch}
      value={value}
      filterOption={(inputValue, option) =>
        option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
      }
    >
      <Input
        id='search-input'
        placeholder='Pesquisar módulo ou página...'
        prefix={
          <SearchOutlined className='mr-0' style={{ color: '#703BE7' }} />
        }
      />
    </AutoComplete>
  );
};

export default SearchInput;
